import { Link } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { useTranslation } from '@wojtekmaj/react-t';

import { BusinessName, LogoWrapper, Wrapper } from './nav.styles';

import Logo from '../../common/logo';
import RewardoLogo from '../../common/rewardo_logo';
import Menu from './menu';

import useAccountPermission from '../../../hooks/useAccountPermission';

import { maybeCurrentBusinessState } from '../../../store';

export default function Nav() {
  const maybeCurrentBusiness = useAtomValue(maybeCurrentBusinessState);
  const titleString = useTranslation('Company logo');

  const shouldDisplayLogoLink = useAccountPermission('public_info_modify');

  return (
    <Wrapper>
      <RewardoLogo width={133} />
      {maybeCurrentBusiness ? (
        <LogoWrapper>
          {shouldDisplayLogoLink ? (
            <Link to="/settings/public_info#logo" title={titleString}>
              <Logo business={maybeCurrentBusiness} size={92} />
            </Link>
          ) : (
            <Logo business={maybeCurrentBusiness} size={92} />
          )}
        </LogoWrapper>
      ) : null}
      {maybeCurrentBusiness ? <BusinessName>{maybeCurrentBusiness.name}</BusinessName> : null}
      <Menu />
    </Wrapper>
  );
}
